import { setConfig } from "~/services/ApiService"
import { defineNuxtPlugin, useNuxtApp } from "#app"

export default defineNuxtPlugin(nuxtApp => {
  const app = useNuxtApp()

  setConfig({
    client: app.$axios,
    baseUrl: "/"
  })
})
